export default "__VITE_ASSET__P2SiBg$v__"